import memoize from "memoize-one"
import { setupProcessingQueueSubscribers } from "@/store/processing/processing-queue"
import { setupAIStylePerformance } from "./processing/ai-style-performance"
import { setupStoreEditorSubscribers } from "@/store/editor/editor-subscribers"
import { cullingImporter } from "./importing/culling-importing"
import { previewImporter } from "./importing/preview-importing"
import { SharedMemoryCounters } from "@/utils/measurement/memory-counters"
import { AI } from "@/lib/ai/ai"
import { initializeTF } from "@/lib/ai/detection/tf"
import { setupProjectsSubscribers } from "./project/projects-state"
import { setupPresetsSubscribers } from "./presets/presets-state"
import { setupGallerySubscribers } from "./Pixieset/store-client-gallery-subs"
export const initializeApp = memoize(async () => {
	await initializeTF()

	setupStoreEditorSubscribers()
	setupProcessingQueueSubscribers()
	setupAIStylePerformance()
	setupProjectsSubscribers()
	setupPresetsSubscribers()
	setupGallerySubscribers()

	cullingImporter.setupSubscribers()
	previewImporter.setupSubscribers()

	await AI.loadModels()

	SharedMemoryCounters.registerAllCounters()
})
